import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "error-wrapper-outer"
}
const _hoisted_2 = { id: "error-wrapper" }
const _hoisted_3 = { id: "error-code" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "An Error occurred", -1)
const _hoisted_5 = { id: "error-message" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { id: "error-info" }, " If this keeps happening, please inform the administrators of this website. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.code), 1),
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1),
          _hoisted_6,
          _createElementVNode("button", {
            class: "btn light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "Dismiss")
        ])
      ]))
    : _createCommentVNode("", true)
}